import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { fetchCategories } from 'LiveBoard/modules/categories'
import { setCategory } from 'LiveBoard/modules/itemsView'
import isEmpty from 'lodash/isEmpty'
import includes from 'lodash/includes'
import Menu from './Menu'


class MenuContainer extends React.Component {

  componentDidMount() {
    const { fetchCategories, board, categories } = this.props
    isEmpty(categories.data) && fetchCategories({ boardId: board.id })
  }

  render() {
    const {
      categories, selectedCategoryId, setCategory, board, config,
      themeColorHex, textColor, solidBackground, showHomeCategory
    } = this.props

    const showMenu = !isEmpty(categories.data)
      || config.cta.show
      || includes(config.social, true)

    return showMenu &&
      <Menu
        categories={categories}
        selectedCategoryId={selectedCategoryId}
        onCategorySelect={setCategory}
        board={board}
        config={config}
        themeColorHex={themeColorHex}
        textColor={textColor}
        solidBackground={solidBackground}
        showHomeCategory={showHomeCategory} />
  }
}

MenuContainer.propTypes = {
  categories: PropTypes.object,
  selectedCategoryId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  board: PropTypes.object,
  config: PropTypes.object.isRequired,
  themeColorHex: PropTypes.string.isRequired,
  textColor: PropTypes.string.isRequired,
  fetchCategories: PropTypes.func,
  setCategory: PropTypes.func,
  solidBackground: PropTypes.bool.isRequired,
  showHomeCategory: PropTypes.bool
}

function mapStateToProps({
  categories,
  board,
  itemsView: { categoryId },
  campaign: { header, themeColorHex, items }
}) {
  return {
    categories,
    selectedCategoryId: categoryId,
    board: board,
    config: header,
    showHomeCategory: items.show_home,
    themeColorHex
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchCategories, setCategory
  }, dispatch)
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuContainer)

